import { yupResolver } from "@hookform/resolvers/yup"
import { Typography, styled } from "@mui/material"
import { FormProvider, useForm } from "react-hook-form"
import { useQueryClient, useStepUpToken } from "../../../../hooks"
import { useToaster } from "../../Toaster"
import { useSecurityDialog } from "../SecurityDialogProvider"
import {
  SecurityDialog,
  SecurityDialogContainer,
  SecurityDialogTitle,
  WrongAccount,
} from "../common"
import { PinDialogForm } from "./PinDialogForm"
import { fields } from "./pinDialog.const"
import { type PinFormValue, pinDialogSchema } from "./pinDialog.schema"
import { usePinDialog } from "./usePinDialog"
import { resendBlockedQueries } from "./utils"

export type PinDialogProps = {
  open: boolean
  goHome: () => void
  closeDialog: () => void
}

export const PinDialog = ({ open, goHome, closeDialog }: PinDialogProps) => {
  const toaster = useToaster()
  const securityDialog = useSecurityDialog()
  const client = useQueryClient()
  const { setStepUpToken } = useStepUpToken()

  const formMethods = useForm<PinFormValue>({
    resolver: yupResolver(pinDialogSchema),
    reValidateMode: "onBlur",
  })
  const { save } = usePinDialog()

  const validateAction = formMethods.handleSubmit(
    async (formValues) =>
      save(formValues, {
        async onSuccess({ access_token }) {
          setStepUpToken(access_token)
          await resendBlockedQueries(client)
          closeDialog()
        },
        onError(error) {
          console.error(error)
          if ("statusCode" in error && error.statusCode === 417) {
            formMethods.setError(fields.password, {
              message: "Code de sécurité incorrect",
            })
          }
        },
      }),
    (errors) => {
      console.error(errors)
      toaster.error("Veuillez remplir correctement le formulaire")
    },
  )

  return (
    <SecurityDialog open={open}>
      <SecurityDialogTitle />
      <SecurityDialogContainer>
        <AdviceLabel>
          Pour accéder à cette partie de l’application, renseignez votre code
          sécurité à 4 chiffres
        </AdviceLabel>
        <FormProvider {...formMethods}>
          <PinDialogForm
            validateAction={validateAction}
            onClickForgottenCode={() =>
              securityDialog.accessCodeForgottenDialog({
                goHome,
              })
            }
          />
        </FormProvider>
      </SecurityDialogContainer>
      <WrongAccount onClickGoHome={goHome} />
    </SecurityDialog>
  )
}

const AdviceLabel = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(16),
  color: theme.palette.grey.dark,
  textAlign: "center",
}))
